// extracted by mini-css-extract-plugin
export default {"expandedTextArea":"content-slot-custom-html-and-css-container__expanded-text-area__Tpv22"};